import { render, staticRenderFns } from "./MemberCreate.vue?vue&type=template&id=59f67c1c&scoped=true&"
import script from "./MemberCreate.vue?vue&type=script&lang=js&"
export * from "./MemberCreate.vue?vue&type=script&lang=js&"
import style0 from "./MemberCreate.vue?vue&type=style&index=0&id=59f67c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f67c1c",
  null
  
)

export default component.exports